import React from "react";

const ComingSoon = () => {
  return (
    <div className=" w-full py-[3rem] flex justify-center items-center md:text-[6rem] text-[4rem] font-bold text-center">
      Coming <br />
      Soon
    </div>
  );
};

export default ComingSoon;
